var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 261.76 226.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.096.001l-30.225 52.351L100.647.001H-.005l130.877 226.688L261.749.001z",
    fill: "#41b883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.096.001l-30.225 52.351L100.647.001H52.346l78.526 136.01L209.398.001z",
    fill: "#34495e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVueLogo);
export default __webpack_public_path__ + "static/media/vue-logo.a5217e60bcb4bc4df54bdbb79efe280a.svg";
export { ForwardRef as ReactComponent };